import { render, staticRenderFns } from "./ReviewReportModal.vue?vue&type=template&id=307a227d&scoped=true&"
import script from "./ReviewReportModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./ReviewReportModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ReviewReportModal.vue?vue&type=style&index=0&id=307a227d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307a227d",
  null
  
)

export default component.exports